import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[3],
  },
  inputContainer: {
    aspectRatio: 4 / 5,
    height: theme.spacing[11],
    paddingHorizontal: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  input: {
    padding: 0,
    textAlign: 'center',
    backgroundColor: colors.backgroundL1,
    borderRadius: theme.borderRadius.m,
    color: colors.textPrimary,
    fontSize: 24,
    fontWeight: '500',
  },
  inputFocused: {
    borderColor: colors.borderSelected,
    borderWidth: 2,
  },
  inputFilled: {
    backgroundColor: colors.backgroundL1,
    borderColor: colors.borderSelected,
  },
  inputDisabled: {
    backgroundColor: colors.backgroundDisabled,
    borderColor: colors.borderDisabled,
    color: colors.textDisabled,
  },
  errorText: {
    marginTop: theme.spacing[2],
    color: colors.textNegative,
    fontSize: 14,
    textAlign: 'center',
  },
}));
